import { Breakpoints, CTA, styled, Text, TokenTextAppearance, TextTag } from '@volkswagen-onehub/components-core';
import React from 'react';
import { getTranslations } from '../translations';
import { Question } from './Question';
import Video from '../components/Video';
import { LayerCloseHandle } from '../types/layers';
import { Close } from '@volkswagen-onehub/icons-core';

interface QuestionInterface {
  id: string;
  question: string;
  answer: string[];
  videoId ?: string;
};

const FAQLayerContainer = styled.div`
  padding: ${(props) => props.theme.size.dynamic0150} 0;
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-rows: auto 1fr;
  @media (min-width: ${Breakpoints.b1280}px) {
    padding: ${(props) => props.theme.size.dynamic0100} 0 0;
  }
`;

const CloseWrapper = styled.div`
  padding: 0 16px;
  grid-column: 2 / -1;
  justify-self: end;
  align-self: center;
`;

const StyledText = styled(Text)`
  margin-left: 16px;
  grid-column: 1 / 2;
  grid-row: 1 / 2;
  align-self: center;
`;

const FAQContentContainer = styled.div`
  margin: 16px;
  grid-column: 1 / -1;
`;

const AnswerContainer = styled.div`
  display: grid;
  row-gap: 16px;
`;

interface Props {
  close: LayerCloseHandle;
}


export const FAQ = ({ close }: Props) => {
  const { aria } = getTranslations();
  const header = getTranslations().volksklick.faqs.header;
  const faqs = getTranslations().volksklick.faqs.questions as QuestionInterface[];

  return (
    <FAQLayerContainer>
      <CloseWrapper>
        <CTA
          tag="button"
          emphasis="none"
          onClick={close as unknown as React.MouseEventHandler<HTMLButtonElement>}
          ariaLabel={aria.close}
          icon={<Close variant="default" />}
          iconPosition="top"
        />
      </CloseWrapper>
      <StyledText tag={TextTag.h2} appearance={TokenTextAppearance.headline300} bold>{header}</StyledText>
      <FAQContentContainer>
        {
          faqs.map(({id, question, answer, videoId}: QuestionInterface, index) => (
            <Question
              defaultOpen={index == 0}
              key={id}
              id={id}
              question={
                <Text tag={TextTag.p} appearance={TokenTextAppearance.headline200} wordBreak={true} bold>
                  { question }
                </Text>
              }
              answer={
                <AnswerContainer>
                  {
                    answer.map((line, i) => {
                      const key = `faq-answer-${i}`;
                      return (
                        <Text key={key} tag={TextTag.p} appearance={TokenTextAppearance.copy200}>
                          { line }
                        </Text>
                      )
                    })
                  }
                  {
                  videoId && <Video id={videoId} />
                  }
                </AnswerContainer>
              }
            />
          ))
        }
      </FAQContentContainer>
    </FAQLayerContainer>
  );
};
